//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageHeader from "@/0/components/comForm/comPageHeader";
import FormEdit from "@/0/components/comForm/comFormEdit2";
import PageFooter from "@/0/components/comForm/comPageFooter2";

export default {
  props: [],
  components: {
    "page-header": PageHeader,
    "form-edit": FormEdit,
    "page-footer": PageFooter,
  },
  data() {
    return {
      
      isShow: false,
      headerConfig: {
        Title: "高级查询"
      },
      controlItem: {},

      Html:null,
      footerConfig: {
        ButtonList: [          
          // {
          //   Text: "关  闭",
          //   Type: "warning",
          //   OnClick: () => {
          //     this._onCloseClick();
          //   }
          // },          

        ]
      },      
    };
  },
  created() {

  },

  methods: {

    async initForm(controlItem) {

      this.headerConfig.Title = controlItem.LabelName;
      this.Html = controlItem.ControlValue;
      
    },


    IsShow() {
      this.isShow = !this.isShow;
    },

    Show(){
      this.isShow = true;
    },

    Hide(){
      this.isShow = false;
    },

    async _onCloseClick() {

      this.Hide();
    },

    
  }
};
